import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { usePlaylistIdFromSearch } from '../hooks';
export const HasParentPlaylist = ({
  children,
  fallback = /*#__PURE__*/_jsx(_Fragment, {})
}) => {
  const playlistId = usePlaylistIdFromSearch();
  if (!playlistId) return /*#__PURE__*/_jsx(_Fragment, {
    children: fallback
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};